import { render, staticRenderFns } from "./SlalomContent.vue?vue&type=template&id=a37ac126&scoped=true"
import script from "./SlalomContent.vue?vue&type=script&lang=js"
export * from "./SlalomContent.vue?vue&type=script&lang=js"
import style0 from "./SlalomContent.vue?vue&type=style&index=0&id=a37ac126&prod&lang=scss"
import style1 from "./SlalomContent.vue?vue&type=style&index=1&id=a37ac126&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37ac126",
  null
  
)

export default component.exports